var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.95 15.2695C29.95 23.5119 23.2424 30.2195 15 30.2195C6.75763 30.2195 0.05 23.5119 0.05 15.2695C0.05 7.02716 6.75755 0.319531 15 0.319531C23.2425 0.319531 29.95 7.02716 29.95 15.2695ZM28.05 15.2695C28.05 8.07186 22.1976 2.2195 15 2.2195C7.80242 2.2195 1.94997 8.07186 1.94997 15.2695C1.94997 22.4672 7.80233 28.3196 15 28.3196C22.1977 28.3196 28.05 22.4672 28.05 15.2695Z",
    fill: "#E9A5F3",
    stroke: "white",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 20.0105L19.4065 20.0107C19.5821 20.153 19.7907 20.2195 20 20.2195C20.2804 20.2195 20.5557 20.096 20.7408 19.8634L20.7409 19.8633C21.0686 19.4549 21.0022 18.8564 20.5937 18.5286L19.4062 20.0105ZM19.4062 20.0105L14.4064 16.0106C14.4064 16.0106 14.4063 16.0106 14.4063 16.0105C14.1829 15.8298 14.05 15.559 14.05 15.2695V7.26951C14.05 6.74712 14.4776 6.31953 15 6.31953C15.5224 6.31953 15.95 6.74712 15.95 7.26951V14.7895V14.8135L15.9687 14.8286L20.5937 18.5285L19.4062 20.0105ZM19.375 20.0495C19.56 20.1995 19.78 20.2695 20 20.2695C20.295 20.2695 20.585 20.1395 20.7799 19.8946L19.375 20.0495Z",
    fill: "#E9A5F3",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockicon);
export default __webpack_public_path__ + "static/media/clockicon.91c7af53725bdbfab80822242272af79.svg";
export { ForwardRef as ReactComponent };